export default {
  baseurl: 'https://digitalize.chachejie.com',
};

export const imgUrlHead = 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/';

export const forklift_img_admin = 'https://resources.chachejie.com/webAdmin/'

export const path = 'wss://digitalizesocket.chachejie.com/wss?access_token='; //socket地址

export const forklift_img = 'https://resources.chachejie.com/mini_image/'; // 叉车图片地址

export const forklift_img_v2 = 'https://resources.chachejie.com/mini_image/v2/'; // 叉车图片地址